import { render, staticRenderFns } from "./china.vue?vue&type=template&id=eca27bf2&scoped=true&"
import script from "./china.vue?vue&type=script&lang=js&"
export * from "./china.vue?vue&type=script&lang=js&"
import style0 from "./china.vue?vue&type=style&index=0&id=eca27bf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca27bf2",
  null
  
)

export default component.exports